const breakPoints = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200,
};

const SHORTEST_INTL_PHONE_LENGTH = 7;

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

const skillLevels = {
  beginner: 32,
  intermediate: 33,
  expert: 66,
};

const RECENT_JOBS_COOKIE = 'recentJobs';

/** sessionStorage: visitor audience slug before signup */
const PRE_SIGNUP_AUDIENCE_STORAGE_KEY = 'twine_pre_signup_audience';

/** sessionStorage: user audience before Stripe checkout redirect */
const PRE_CHECKOUT_AUDIENCE_STORAGE_KEY = 'twine_pre_checkout_audience';

const PORTFOLIO_AD_ROTATION_MILLISECONDS = 20000;

const TODAY = new Date();

const DEFAULT_LOCALE = 'en-US';

// Pinder
const DEFAULT_PENDING_PITCHES_TO_LOAD = 3;

const FREE_USER_JOB_PITCH_LIMIT = 15;

const VERY_POPULAR_PITCH_COUNT = 20;

export {
  RECENT_JOBS_COOKIE,
  PRE_SIGNUP_AUDIENCE_STORAGE_KEY,
  PRE_CHECKOUT_AUDIENCE_STORAGE_KEY,
  breakPoints,
  DEFAULT_LOCALE,
  SHORTEST_INTL_PHONE_LENGTH,
  skillLevels,
  TODAY,
  PORTFOLIO_AD_ROTATION_MILLISECONDS,
  DEFAULT_PENDING_PITCHES_TO_LOAD,
  MILLISECONDS_PER_DAY,
  FREE_USER_JOB_PITCH_LIMIT,
  VERY_POPULAR_PITCH_COUNT,
};
